import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-loading-animation',
  templateUrl: './loading-animation.component.html',
  styleUrl: './loading-animation.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class LoadingAnimationComponent {
  protected useLegacy =
    ['trident', 'edge', 'firefox'].findIndex(
      (key) => navigator.userAgent.toLowerCase().indexOf(key) > -1
    ) > -1;

  text: string = 'Loading...';
}
